<template>
  <b-container>
    <b-row>
      <b-col class="my-4">
        <div class="main-banner">
          <img
            :src="
              (diagnosticBanner.icon && diagnosticBanner.icon.fileUrl) || ''
            "
            alt="Diagnostic Center Top Banner"
          />
        </div>
        <div>
          <b-row class="my-4">
            <b-col
              md="4"
              v-for="diagnose in diagonseCategory"
              :key="diagnose.category"
            >
              <div
                @click="diagnoseCategoryClick(diagnose.category)"
                class="diagnose-category"
                :style="{
                  backgroundImage: 'url(' + diagnose.backgroundImage + ')',
                }"
              >
                <p>{{ diagnose.category }}</p>
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="main-banner">
          <img
            :src="
              (diagnosticBanner.icon && diagnosticBanner.icon.fileUrl) || ''
            "
            alt="Diagnostic Center Top Banner"
          />
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      diagonseCategory: [
        { category: "Thyroid", backgroundImage: "/public/img/Add.png" },
        { category: "Lifestyle", backgroundImage: "/public/img/Add.png" },
        { category: "Blood Test", backgroundImage: "/public/img/Add.png" },
        { category: "Urine Test", backgroundImage: "/public/img/Add.png" },
        { category: "Package Test", backgroundImage: "/public/img/Add.png" },
        { category: "Health Checkup", backgroundImage: "/public/img/Add.png" },
        { category: "Diabetes", backgroundImage: "/public/img/Add.png" },
        { category: "Heart", backgroundImage: "/public/img/Add.png" },
        { category: "Kidney Test", backgroundImage: "/public/img/Add.png" },
        { category: "HIV Test", backgroundImage: "/public/img/Add.png" },
      ],
    };
  },

  computed: {
    ...mapState({
      diagnosticBanner: (state) => state.healthCare.marketBanner,
    }),
  },

  methods: {
    diagnoseCategoryClick(diagnoseCategory) {
      console.log(diagnoseCategory, "Click");
      if (diagnoseCategory === "Package Test") {
        this.$router.push({ name: "package-test" });
      } else {
        // this.$router.push({ name: "pharmacy-Shop" });
        this.$router.push({ name: "diagnostic-center-listing" });
      }
    },
  },

  async mounted() {
    this.isLoading = true;
    let payload = {
      city: "GHATAL",
      placement: "DIAGONOSTICS_TOP",
    };
    await this.$store.dispatch("healthCare/fetchMarketBanner", payload);

    this.isLoading = false;
  },
};
</script>

<style scoped>
.diagnose-category {
  display: flex;
  align-items: center;
  height: 100px;
  padding-left: 6px;
  color: #ffffff;
  background: blue url(/public/img/Add.png) no-repeat scroll 0px 0px;
  cursor: pointer;
}
</style>
